import { defineStore } from 'pinia';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';
import { getAnotherLang, getLocalLang, setLocalLang } from '@/i18n/utils';
// import { i18n } from '../i18n/i18n';

type Lang = 'zh-CN' | 'en-US';
interface State {
  lang: Lang;
  localOptions: Array<{
    label: string;
    value: string;
  }>;
  config: {
    zhCN: typeof zhCN;
    enUS: typeof enUS;
  };
}

export const useUserConfigStore = defineStore('userStore', {
  state: (): State => {
    return {
      lang: getLocalLang(),
      localOptions: [
        {
          label: 'zh-CN',
          value: 'zh-CN',
        },
        {
          label: 'en-US',
          value: 'en-US',
        },
      ],
      config: {
        zhCN,
        enUS,
      },
    };
  },
  getters: {
    locale: (state) => {
      const { lang } = state;
      setLocalLang(lang);
      if (lang === 'zh-CN') return zhCN;
      if (lang === 'en-US') return enUS;
      return enUS;
    },
  },
  actions: {
    toggleLang(v: Lang) {
      console.log(v, '===========lang');
      this.lang = v;
    },
  },
});
